import(/* webpackMode: "eager" */ "/opt/webrtc/app/page.tsx");
